import { createBaseStore } from '@/zustand/create-store';
import { STORAGE_KEYS } from '@/zustand/storage-keys';
import { AppSettings } from '@/zustand/app-settings/app-settings.ts';

const initialState: AppSettings = {
	isOpenBankInformation: false,
	notifications: {
		background_mode: false,
		notification: false
	}
};

export const useAppSettings = createBaseStore<AppSettings>(STORAGE_KEYS.APP_SETTINGS_STORAGE, initialState, undefined, {
	shouldPersist: false
});
